import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {deleteIssueCommentMutation} from './__generated__/deleteIssueCommentMutation.graphql'

export const deleteCommentFragment = graphql`
  fragment deleteIssueCommentMutation_Comment on IssueComment {
    id
    viewerCanDelete
  }
`

export function commitDeleteIssueCommentMutation({
  environment,
  input: {id},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {id: string}
  onCompleted?: () => void
  onError?: (error?: Error) => void
}) {
  return commitMutation<deleteIssueCommentMutation>(environment, {
    mutation: graphql`
      mutation deleteIssueCommentMutation($input: DeleteIssueCommentInput!) @raw_response_type {
        deleteIssueComment(input: $input) {
          clientMutationId
        }
      }
    `,
    variables: {
      input: {id},
    },
    onCompleted: response => {
      if (response.deleteIssueComment === null) {
        onError?.()
      } else {
        onCompleted?.()
      }
    },
    onError: error => onError?.(error),
  })
}
